import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "facture-print w-full sm:px-6 pt-1 pb-8" }
const _hoisted_2 = { class: "print-only mb-6" }
const _hoisted_3 = { style: {"font-size":"18px","font-weight":"700","margin":"0"} }
const _hoisted_4 = { style: {"font-size":"13px","margin-top":"4px"} }
const _hoisted_5 = { class: "flex flex-wrap justify-start items-center gap-4 mb-4 no-print" }
const _hoisted_6 = { class: "flex rounded-md border border-gray-300 overflow-hidden" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-8" }
const _hoisted_10 = { class: "px-6 py-4 border-b border-gray-200 flex items-center justify-between" }
const _hoisted_11 = { class: "text-lg font-medium text-black" }
const _hoisted_12 = ["aria-expanded", "title"]
const _hoisted_13 = { class: "overflow-x-auto collapsible-print" }
const _hoisted_14 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_15 = { class: "bg-gray-50" }
const _hoisted_16 = { class: "px-6 py-3 text-right text-xs font-medium text-black uppercase tracking-wider" }
const _hoisted_17 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_18 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = ["src", "alt", "onError"]
const _hoisted_22 = {
  key: 1,
  class: "mr-2 text-base"
}
const _hoisted_23 = {
  key: 1,
  class: "w-4 h-4 bg-gray-300 rounded mr-2"
}
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black" }
const _hoisted_26 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black text-right" }
const _hoisted_27 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black text-right" }
const _hoisted_28 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black text-right" }
const _hoisted_29 = { class: "bg-gray-100 font-bold" }
const _hoisted_30 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black text-right" }
const _hoisted_31 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black text-right" }
const _hoisted_32 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black text-right" }
const _hoisted_33 = { class: "ml-4 my-4 no-print" }
const _hoisted_34 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_35 = {
  class: "border border-green-300 border-dashed rounded-md bg-white",
  style: {"padding":"14px 16px"}
}
const _hoisted_36 = { class: "text-base font-medium text-black mb-1 text-left" }
const _hoisted_37 = { class: "text-sm text-black text-center" }
const _hoisted_38 = { class: "ml-2" }
const _hoisted_39 = { class: "ml-2 text-green-600 font-semibold" }
const _hoisted_40 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8" }
const _hoisted_41 = { class: "lg:col-span-2" }
const _hoisted_42 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_43 = { class: "px-6 py-4 border-b border-gray-200 flex items-center justify-between" }
const _hoisted_44 = { class: "text-lg font-medium text-black" }
const _hoisted_45 = ["aria-expanded", "title"]
const _hoisted_46 = {
  key: 0,
  class: "px-6 py-4 text-sm text-black"
}
const _hoisted_47 = {
  key: 1,
  class: "overflow-x-auto collapsible-print"
}
const _hoisted_48 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_49 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_50 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black" }
const _hoisted_51 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black" }
const _hoisted_52 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black text-center" }
const _hoisted_53 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black text-right" }
const _hoisted_54 = { class: "lg:col-span-1" }
const _hoisted_55 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_56 = { class: "space-y-3" }
const _hoisted_57 = { class: "flex justify-between items-center" }
const _hoisted_58 = { class: "text-sm font-medium text-black" }
const _hoisted_59 = {
  key: 0,
  class: "flex justify-between items-center"
}
const _hoisted_60 = { class: "text-sm font-medium text-red-600" }
const _hoisted_61 = { class: "flex justify-between items-center" }
const _hoisted_62 = { class: "text-sm font-medium text-black" }
const _hoisted_63 = { class: "flex justify-between items-center" }
const _hoisted_64 = { class: "text-sm font-medium text-black" }
const _hoisted_65 = { class: "border-t border-gray-200 pt-3" }
const _hoisted_66 = { class: "flex justify-between items-center" }
const _hoisted_67 = { class: "text-sm font-bold text-black" }
const _hoisted_68 = { class: "flex justify-between items-center" }
const _hoisted_69 = { class: "text-sm text-black" }
const _hoisted_70 = { class: "text-sm font-medium text-black" }
const _hoisted_71 = { class: "border-t border-gray-200 pt-3" }
const _hoisted_72 = { class: "flex justify-between items-center" }
const _hoisted_73 = { class: "text-lg font-bold text-black" }
const _hoisted_74 = { class: "flex justify-center gap-4 no-print" }
const _hoisted_75 = ["href"]

import { ref, computed, onMounted, nextTick } from 'vue'
import { PageHeader, UnifiedPagination } from '@/components'
import { fetchApi, getApiBaseUrl } from '@/config/api'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'
import { extractAdminCalendarDate } from '@/utils/adminOrderDisplay'
import { getDomTomIsoFromPostalCode } from '@/utils/domTom'

type TransactionRow = {
  id: number | string
  date: string
  societe: string
  adresseFacturation: string
  montantHT: number
  tva: number
  montantTotal: number
  paysLivraisonCode2?: string | null
  paysLivraisonNom?: string | null
  paysFacturationCode2?: string | null
  paysFacturationNom?: string | null
  codePostalLivraison?: string | null
}
type ServiceRow = { id?: number | string; libelle: string; quantite: number; montant: number }
type SummaryBox = {
  prestationServiceEPF: number
  remiseCommissionEfpHT: number
  remboursementCommission: number
  prestationsHT: number
  totalHT: number
  tva: number
  totalTTC: number
  tvaRateLabel: string
}

// Type de facture : mensuel ou bimensuel

export default /*@__PURE__*/_defineComponent({
  __name: 'FactureView',
  setup(__props) {

const authStore = useAuthStore()
const router = useRouter()

const factureType = ref<'mensuel' | 'bimensuel'>('bimensuel')

const selectedPeriod = ref<string>('')
const availablePeriods = ref<string[]>([])
const sellerName = ref<string>('')

const currentData = ref<{ transactions: TransactionRow[]; services: ServiceRow[]; summary: SummaryBox; facture: any }>({
  transactions: [],
  services: [],
  summary: { prestationServiceEPF: 0, remiseCommissionEfpHT: 0, remboursementCommission: 0, prestationsHT: 0, totalHT: 0, tva: 0, totalTTC: 0, tvaRateLabel: '20%' },
  facture: null
})

const invoiceUrl = computed(() => {
  const noFacture = currentData.value.facture?.noFacture
  const idVendeur = authStore.user?.id
  if (!noFacture || !idVendeur) return ''
  // Passe par le backend : v1 prioritaire (et recopié sur S3), puis S3,
  // puis génération sur S3 si la facture n'existe sur aucun des deux.
  // Le paramètre versionné contourne l'ancienne réponse PDF mise en cache sous
  // localhost ; le backend redirige ensuite vers storage.efashion-paris.com.
  return `${getApiBaseUrl()}/facturePDF/vendeurs/${idVendeur}/${noFacture}FR.pdf?storage=v2`
})

const isBeforeFeb2026 = computed(() => {
  if (!selectedPeriod.value) return true
  return selectedPeriod.value.substring(0, 7) < '2026-02'
})

// Totaux
const totalMontantHT = computed(() => currentData.value.transactions.reduce((s, t) => s + (t.montantHT || 0), 0))
const totalTVA = computed(() => currentData.value.transactions.reduce((s, t) => s + (t.tva || 0), 0))
const totalMontantTotal = computed(() => currentData.value.transactions.reduce((s, t) => s + (t.montantTotal || 0), 0))

// Pagination
const currentPageTx = ref<number>(1)
const itemsPerPageTx = ref<number>(10)
function isTransactionOnPage(index: number): boolean {
  const start = (currentPageTx.value - 1) * itemsPerPageTx.value
  return index >= start && index < start + itemsPerPageTx.value
}
function handleTxPageChange(page: number) { currentPageTx.value = page }
function handleTxItemsPerPageChange(size: number) { itemsPerPageTx.value = size; currentPageTx.value = 1 }

// Collapse states
const txOpen = ref(true)
const servicesOpen = ref(true)

function ym(date: Date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
}

function formatDate(d: string | null | undefined): string {
  if (!d) return ''
  const s = d.substring(0, 10)
  const [y, m, day] = s.split('-')
  if (!y || !m || !day) return d as string
  return `${day}/${m}/${y}`
}

function formatDateTime(d: string | null | undefined): string {
  if (!d) return ''
  const date = d.substring(0, 10)
  const time = d.length > 10 ? d.substring(11, 19) : ''
  const [y, m, day] = date.split('-')
  if (!y || !m || !day) return d as string
  return `${day}/${m}/${y}${time ? ' ' + time : ''}`
}

const months = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre']

const periodLong = computed(() => {
  const p = selectedPeriod.value
  if (!p) return ''
  const base = p.substring(0, 7)
  const [y, m] = base.split('-').map(Number)
  const name = months[(m || 1) - 1] || base
  if (factureType.value === 'bimensuel') {
    const demi = p.endsWith('S1') ? ' (S1)' : p.endsWith('S2') ? ' (S2)' : ''
    return `${name} ${y || ''}${demi}`.trim()
  }
  return `${name} ${y || ''}`.trim()
})

function labelPeriod(period: string): string {
  if (factureType.value === 'mensuel' && period === '2025-10-09') return '09 octobre 2025'
  const base = period.substring(0, 7)
  const [y, m] = base.split('-').map(Number)
  const name = months[(m || 1) - 1] || base
  if (factureType.value === 'bimensuel') {
    const demi = period.endsWith('S1') ? ' (S1)' : period.endsWith('S2') ? ' (S2)' : ''
    return `${name} ${y}${demi}`
  }
  return `${name} ${y || ''}`.trim()
}

function buildPeriods(): void {
  const periods: string[] = []
  const now = new Date()

  if (factureType.value === 'mensuel') {
    for (let i = 0; i < 100; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1)
      const yym = ym(d)
      if (yym > '2025-10') continue
      if (yym === '2025-10') {
        if (!periods.includes('2025-10-09')) periods.push('2025-10-09')
        continue
      }
      periods.push(yym)
    }
  } else {
    for (let i = 0; i < 100; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1)
      const yym = ym(d)
      if (yym < '2025-10') break
      if (yym === '2025-10') {
        periods.push('2025-10')
        break
      } else {
        periods.push(`${yym}-S2`)
        periods.push(`${yym}-S1`)
      }
    }
  }

  availablePeriods.value = periods
  selectedPeriod.value = periods[0]
}

async function fetchVendeurCA(fdate: string) {
  const idVendeur = authStore.user?.id
  const query = `query($id:Int!,$fd:String!){ vendeurCA(id_vendeur:$id, fdate:$fd) }`
  const res = await fetchApi<{ vendeurCA: string }>(query, { id: Number(idVendeur), fd: fdate })
  return res?.vendeurCA ? JSON.parse(res.vendeurCA) : null
}

function round2(n: number): number { return Math.round((Number(n) + Number.EPSILON) * 100) / 100 }

function mapToUI(data: any): void {
  if (!data) {
    currentData.value = {
      transactions: [],
      services: [],
      summary: { prestationServiceEPF: 0, remiseCommissionEfpHT: 0, remboursementCommission: 0, prestationsHT: 0, totalHT: 0, tva: 0, totalTTC: 0, tvaRateLabel: '—' },
      facture: null
    }
    sellerName.value = ''
    return
  }
  sellerName.value = String(data.nomSociete || '')
  const commandes = data.commandes || {}
  const beforeFeb2026 = isBeforeFeb2026.value

  const txs: TransactionRow[] = Object.keys(commandes).map((k) => {
    const c = commandes[k]
    let ht: number
    if (factureType.value === 'mensuel') {
      ht = beforeFeb2026 ? Number(c.montantApresRemise || 0) : Number(c.montantCA || c.montantApresRemise || 0)
    } else {
      const rawCA = Number(c.montantCA)
      ht = rawCA > 0 ? rawCA : Number(c.montantApresRemise || 0)
    }
    const tva = Number(c.tva || 0)
    const ttc = c.montantTTC != null ? Number(c.montantTTC) : ht
    return {
      id: c.id_commande,
      date: extractAdminCalendarDate(c.dateCommande) || '',
      societe: c.nomSociete || '',
      adresseFacturation: c.adresseFacturation || '',
      montantHT: round2(ht),
      tva: round2(tva),
      montantTotal: round2(ttc),
      paysLivraisonCode2: c.pays_livraison_code2 || null,
      paysLivraisonNom: c.pays_livraison_nom || null,
      paysFacturationCode2: c.pays_facturation_code2 || null,
      paysFacturationNom: c.pays_facturation_nom || null,
      codePostalLivraison: c.codepostal_livraison || null,
    }
  }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())

  const services: ServiceRow[] = (data.prestationsDetail?.lignes || []).map((p: any) => ({
    id: p.id_vendeur_prestation,
    libelle: p.libelle,
    quantite: Number(p.quantite || 0),
    montant: round2(Number(p.montant || 0))
  }))

  const prestationServiceEPF = Number(data.commissionEFP || 0)
  const remiseCommissionEfpHT = Number(data.RemiseCommissionHT || data.remiseCommissionHT || 0)
  const remboursementCommission = Number(data.commissionBanque || 0)
  const prestationsHT = Number(data.prestationsHT || 0)
  const totalHT = Number(data.montantFactureHT || 0)
  const totalTTC = Number(data.montantFactureTTC || 0)
  const tva = Number(data.montantFactureTva || (totalTTC - totalHT))
  const tvaRate = totalHT > 0 ? (tva / totalHT) : 0
  const tvaRateLabel = `${round2(tvaRate * 100)}%`

  currentData.value = {
    transactions: txs,
    services,
    summary: {
      prestationServiceEPF: round2(prestationServiceEPF),
      remiseCommissionEfpHT: round2(remiseCommissionEfpHT),
      remboursementCommission: round2(remboursementCommission),
      prestationsHT: round2(prestationsHT),
      totalHT: round2(totalHT),
      tva: round2(tva),
      totalTTC: round2(totalTTC),
      tvaRateLabel,
    },
    facture: data.facture ? {
      noFacture: data.facture.no_facture ?? null,
      montantReglement: data.facture.montant_reglement ?? null,
      prestations: data.facture.prestations ?? null,
      dateReglement: data.facture.date_reglement ?? null,
      reglement: data.facture.reglement ?? null,
    } : null
  }
}

async function switchType(type: 'mensuel' | 'bimensuel'): Promise<void> {
  if (factureType.value === type) return
  factureType.value = type
  buildPeriods()
  const data = await fetchVendeurCA(selectedPeriod.value)
  mapToUI(data)
  currentPageTx.value = 1
}

async function handlePeriodChange(): Promise<void> {
  const data = await fetchVendeurCA(selectedPeriod.value)
  mapToUI(data)
  currentPageTx.value = 1
}

async function handlePrint(): Promise<void> {
  await nextTick()
  requestAnimationFrame(() => window.print())
}

function escapeCsvField(v: any): string {
  return '"' + String(v ?? '').replace(/"/g, '""') + '"'
}

function handleExportExcel(): void {
  const headers = ['Date','Société','Adresse de facturation','Montant HT','TVA','Montant TTC']
  const rows = currentData.value.transactions.map((t: any) => [
    formatDate(t.date), t.societe, t.adresseFacturation,
    Number(t.montantHT || 0).toFixed(2),
    Number(t.tva || 0).toFixed(2),
    Number(t.montantTotal || 0).toFixed(2)
  ])
  const lines = ['sep=,', headers.map(escapeCsvField).join(','), ...rows.map((r: any[]) => r.map(escapeCsvField).join(','))]
  const csv = lines.join('\r\n')
  const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
  const blob = new Blob([bom, csv], { type: 'text/csv; charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `facture-${factureType.value}-${selectedPeriod.value}.csv`
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

// Flags helpers
function iso2ToFlag(code?: string | null): string {
  if (!code || code.length !== 2) return ''
  const up = code.toUpperCase()
  return String.fromCodePoint(up.charCodeAt(0) - 65 + 0x1F1E6) + String.fromCodePoint(up.charCodeAt(1) - 65 + 0x1F1E6)
}
function flagImgUrl(code?: string | null): string {
  if (!code || code.length !== 2) return ''
  return `https://flagcdn.com/24x18/${code.toLowerCase()}.png`
}
const failedFlagCodes = ref<Set<string>>(new Set())
function onFlagImgError(code?: string | null): void { if (code) failedFlagCodes.value.add(code.toUpperCase()) }
function hasFlagImgError(code?: string | null): boolean { return !code ? false : failedFlagCodes.value.has(code.toUpperCase()) }
function flagCode(t: TransactionRow): string | null | undefined {
  const base = (t.paysLivraisonCode2 || t.paysFacturationCode2 || '').toUpperCase()
  if (!base) return null
  if (base === 'FR') { const override = getDomTomIsoFromPostalCode(t.codePostalLivraison); if (override) return override }
  return base
}
function flagTitle(t: TransactionRow): string { return (t.paysLivraisonNom || t.paysFacturationNom || '') as string }

onMounted(async () => {
  const ok = await authStore.checkAuth()
  if (!ok) { router.push({ name: 'auth' }); return }
  buildPeriods()
  const data = await fetchVendeurCA(selectedPeriod.value)
  mapToUI(data)
  currentPageTx.value = 1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(PageHeader), {
      class: "no-print mb-4 pr-10",
      title: "Mes factures",
      subtitle: "Récapitulatif des transactions et prestations"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_3, "Facture " + _toDisplayString(periodLong.value), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(sellerName.value ? ' - ' + sellerName.value : ''), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 text-sm font-medium transition-colors border-r border-gray-300", factureType.value === 'bimensuel' ? 'bg-indigo-600 text-white' : 'bg-white text-black hover:bg-gray-50']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (switchType('bimensuel')))
          }, " Bimensuel ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 text-sm font-medium transition-colors", factureType.value === 'mensuel' ? 'bg-indigo-600 text-white' : 'bg-white text-black hover:bg-gray-50']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (switchType('mensuel')))
          }, " Mensuel ", 2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            for: "period-select",
            class: "text-sm font-medium text-black pr-2"
          }, "Période :", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "period-select",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedPeriod).value = $event)),
            onChange: handlePeriodChange,
            class: "px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availablePeriods.value, (period) => {
              return (_openBlock(), _createElementBlock("option", {
                key: period,
                value: period
              }, _toDisplayString(labelPeriod(period)), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, selectedPeriod.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h3", _hoisted_11, "Transactions de " + _toDisplayString(periodLong.value), 1),
          _createElementVNode("button", {
            class: "inline-flex items-center gap-2 text-sm text-black hover:text-black",
            "aria-expanded": txOpen.value.toString(),
            title: txOpen.value ? 'Réduire' : 'Développer',
            onClick: _cache[3] || (_cache[3] = ($event: any) => (txOpen.value = !txOpen.value))
          }, [
            _createElementVNode("span", null, _toDisplayString(txOpen.value ? 'Réduire' : 'Afficher'), 1),
            _createElementVNode("i", {
              class: _normalizeClass(["fas fa-chevron-down transition-transform duration-200", txOpen.value ? 'rotate-0' : '-rotate-90'])
            }, null, 2)
          ], 8, _hoisted_12)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _createElementVNode("thead", _hoisted_15, [
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Date", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Société", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Adresse de facturation", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("th", { class: "px-6 py-3 text-right text-xs font-medium text-black uppercase tracking-wider" }, "Montant HT", -1)),
                _createElementVNode("th", _hoisted_16, "TVA (" + _toDisplayString(currentData.value.summary.tvaRateLabel) + ")", 1),
                _cache[10] || (_cache[10] = _createElementVNode("th", { class: "px-6 py-3 text-right text-xs font-medium text-black uppercase tracking-wider" }, "Montant Total", -1))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentData.value.transactions, (transaction, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: transaction.id,
                  class: _normalizeClass(["hover:bg-gray-50", { 'print-only-row': !isTransactionOnPage(index) }])
                }, [
                  _createElementVNode("td", _hoisted_18, _toDisplayString(formatDate(transaction.date)), 1),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (flagCode(transaction))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (!hasFlagImgError(flagCode(transaction)!))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: flagImgUrl(flagCode(transaction)!),
                                  alt: flagCode(transaction) || '',
                                  class: "mr-2 inline-block align-middle",
                                  style: {"width":"18px","height":"13px","border-radius":"2px","object-fit":"cover"},
                                  onError: ($event: any) => (onFlagImgError(flagCode(transaction)!))
                                }, null, 40, _hoisted_21))
                              : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(iso2ToFlag(flagCode(transaction)) || flagCode(transaction)), 1))
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23)),
                      _createElementVNode("span", {
                        class: "text-sm font-medium text-black",
                        title: flagTitle(transaction)
                      }, _toDisplayString(transaction.societe), 9, _hoisted_24)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(transaction.adresseFacturation), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(transaction.montantHT.toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_27, [
                    (Number(transaction.tva) === 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("-")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(transaction.tva.toFixed(2)), 1)
                        ], 64))
                  ]),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(transaction.montantTotal.toFixed(2)), 1)
                ], 2))
              }), 128)),
              _createElementVNode("tr", _hoisted_29, [
                _cache[11] || (_cache[11] = _createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-sm text-black" }, "Total", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-sm text-black" }, null, -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-sm text-black" }, null, -1)),
                _createElementVNode("td", _hoisted_30, _toDisplayString(totalMontantHT.value.toFixed(2)), 1),
                _createElementVNode("td", _hoisted_31, _toDisplayString(totalTVA.value.toFixed(2)), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString(totalMontantTotal.value.toFixed(2)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_unref(UnifiedPagination), {
              "current-page": currentPageTx.value,
              "total-items": currentData.value.transactions.length,
              "items-per-page": itemsPerPageTx.value,
              "show-first-last-buttons": true,
              onPageChange: handleTxPageChange,
              onItemsPerPageChange: handleTxItemsPerPageChange
            }, null, 8, ["current-page", "total-items", "items-per-page"])
          ])
        ], 512), [
          [_vShow, txOpen.value]
        ])
      ]),
      (currentData.value.facture)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_36, " Règlement de la facture de " + _toDisplayString(periodLong.value), 1),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", null, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "font-medium" }, "Date de règlement :", -1)),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(formatDateTime(currentData.value.facture.dateReglement)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "font-medium" }, "Montant du règlement :", -1)),
                    _createElementVNode("span", _hoisted_39, _toDisplayString(Number(currentData.value.facture.montantReglement || 0).toFixed(2)) + "€", 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("h3", _hoisted_44, "Liste des prestations de " + _toDisplayString(periodLong.value), 1),
              _createElementVNode("button", {
                class: "inline-flex items-center gap-2 text-sm text-black hover:text-black",
                "aria-expanded": servicesOpen.value.toString(),
                title: servicesOpen.value ? 'Réduire' : 'Développer',
                onClick: _cache[4] || (_cache[4] = ($event: any) => (servicesOpen.value = !servicesOpen.value))
              }, [
                _createElementVNode("span", null, _toDisplayString(servicesOpen.value ? 'Réduire' : 'Afficher'), 1),
                _createElementVNode("i", {
                  class: _normalizeClass(["fas fa-chevron-down transition-transform duration-200", servicesOpen.value ? 'rotate-0' : '-rotate-90'])
                }, null, 2)
              ], 8, _hoisted_45)
            ]),
            (currentData.value.services.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _cache[16] || (_cache[16] = _createTextVNode(" Ce grossiste n'a aucune prestation pour la période ")),
                  _createElementVNode("strong", null, _toDisplayString(periodLong.value), 1)
                ]))
              : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("table", _hoisted_48, [
                    _cache[17] || (_cache[17] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "#"),
                        _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Libellé"),
                        _createElementVNode("th", { class: "px-6 py-3 text-center text-xs font-medium text-black uppercase tracking-wider" }, "Quantité"),
                        _createElementVNode("th", { class: "px-6 py-3 text-right text-xs font-medium text-black uppercase tracking-wider" }, "Montant (€)")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_49, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentData.value.services, (service) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: service.id,
                          class: "hover:bg-gray-50"
                        }, [
                          _createElementVNode("td", _hoisted_50, _toDisplayString(service.id), 1),
                          _createElementVNode("td", _hoisted_51, _toDisplayString(service.libelle), 1),
                          _createElementVNode("td", _hoisted_52, _toDisplayString(service.quantite), 1),
                          _createElementVNode("td", _hoisted_53, _toDisplayString(service.montant.toFixed(2)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 512)), [
                  [_vShow, servicesOpen.value]
                ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "text-lg font-medium text-black mb-4" }, "Résumé financier", -1)),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-sm text-black" }, "Prestation service EPF 10% (HT) (€):", -1)),
                _createElementVNode("span", _hoisted_58, _toDisplayString(currentData.value.summary.prestationServiceEPF.toFixed(2)), 1)
              ]),
              (isBeforeFeb2026.value && currentData.value.summary.remiseCommissionEfpHT > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-sm text-black" }, "Remise Commission EFP HT (€) :", -1)),
                    _createElementVNode("span", _hoisted_60, "- " + _toDisplayString(currentData.value.summary.remiseCommissionEfpHT.toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_61, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-sm text-black" }, "Remboursement de la commission bancaire HT (€):", -1)),
                _createElementVNode("span", _hoisted_62, _toDisplayString(currentData.value.summary.remboursementCommission.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_63, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-sm text-black" }, "Prestations HT (€):", -1)),
                _createElementVNode("span", _hoisted_64, _toDisplayString(currentData.value.summary.prestationsHT.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm font-medium text-black" }, "Total HT (€):", -1)),
                  _createElementVNode("span", _hoisted_67, _toDisplayString(currentData.value.summary.totalHT.toFixed(2)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("span", _hoisted_69, "TVA (" + _toDisplayString(currentData.value.summary.tvaRateLabel) + ") (€):", 1),
                _createElementVNode("span", _hoisted_70, _toDisplayString(currentData.value.summary.tva.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-sm font-bold text-black" }, "Total TTC (€):", -1)),
                  _createElementVNode("span", _hoisted_73, _toDisplayString(currentData.value.summary.totalTTC.toFixed(2)), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("button", {
          onClick: handleExportExcel,
          class: "inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
        }, _cache[25] || (_cache[25] = [
          _createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1),
          _createTextVNode(" Exporter en Excel ")
        ])),
        _createElementVNode("button", {
          onClick: handlePrint,
          class: "inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-black bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
        }, _cache[26] || (_cache[26] = [
          _createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1),
          _createTextVNode(" Imprimer le récapitulatif ")
        ])),
        (currentData.value.facture?.noFacture)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: invoiceUrl.value,
              target: "_blank",
              class: "inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-black bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
            }, [
              _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-file-pdf mr-2" }, null, -1)),
              _createTextVNode(" Voir la facture" + _toDisplayString(currentData.value.facture.noFacture), 1)
            ], 8, _hoisted_75))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})